import {
  formatValue,
  getDataSource,
} from '@rsos/components/capstone/Location/helpers';
import { formatInternationalPhoneNumberE164 } from '@rsos/utils/internationalPhoneNumberUtils';
import isValidCoordinates from '@rsos/utils/isValidCoordinates';
import { parseADRtoCopy } from '@rsos/utils/parseADRToCopyUtils';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';

export const getCallerLocationData = (location, what3words) => {
  const {
    altitude = null,
    altitude_uncertainty_radius = null,
    call_start_time = null,
    caller_id = null,
    latitude = null,
    location_time = null,
    longitude = null,
    rg_address = null,
    rg_exact_location = null,
    rg_floor = null,
    rgAddress = null,
    rgAddressProvider = null,
    timestamp = null,
    uncertainty_confidence = null,
    uncertainty_radius = null,
  } = location;

  const hasValidCoords = isValidCoordinates(location);

  return {
    callerID:
      formatInternationalPhoneNumberE164(caller_id)?.slice(1) || caller_id,
    source: getDataSource(location),
    locationTime: convertUnixTimestamp(
      parseFloat(timestamp || location_time || call_start_time),
    ),
    estimatedAddress: rg_address || rgAddress,
    estimatedAddressProvider: rgAddressProvider,
    estimatedFloor: rg_exact_location || rg_floor,
    latitude: hasValidCoords ? formatValue(latitude) : null,
    longitude: hasValidCoords ? formatValue(longitude) : null,
    what3words: what3words ? `https://what3words.com/${what3words}` : null,
    altitude: altitude ? `${parseFloat(altitude).toFixed(1)} meters` : null,
    altitudeUncertaintyRadius: altitude_uncertainty_radius
      ? `${Number(altitude_uncertainty_radius).toFixed(0)} meters`
      : null,
    uncertaintyRadius: hasValidCoords
      ? `${Number(uncertainty_radius).toFixed(1)} meters`
      : null,
    uncertaintyConfidence:
      hasValidCoords && uncertainty_confidence
        ? `${uncertainty_confidence} %`
        : null,
  };
};

/**
 * Parses through the additionalData Object, removes hidden formats and no-types, and returns a copyable string
 * @param {Array} adrList - Full Object of Additional Data
 * @returns {String} Additional Data object converted to a string
 */
export const getCopyableAdditionalData = additionalData => {
  if (!additionalData) {
    return '';
  }

  let jsonString = '';

  Object.keys(additionalData).forEach(org => {
    additionalData[org].forEach(dataSet => {
      const adr = parseADRtoCopy(dataSet.display_schema, dataSet.data);
      jsonString += adr ? `\n${dataSet.display_schema?.title}\n${adr}\n` : '';
    });
  });

  return jsonString.trim();
};
